import { Spinner } from './components/Spinner'

export function FullPageSpinner() {
  return (
    <div className="flex h-dvh items-center justify-center bg-background">
      <Spinner size="lg" color="primary" />
    </div>
  )
}
